module.exports = __webpack_public_path__ + "img/mobile_inbox.fdc3308c.svg";